var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OnboardingTextSection',{staticClass:"onboarding-image-section",class:{
    'onboarding-image-section__center': _vm.alignCenter
  }},[_c('img',{staticClass:"onboarding-image-section__image",attrs:{"src":_vm.image,"width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }